export class DeleteProjectRole {

  query = (id:string) => ({
    url: `/role_access/${id}`,
    method: 'DELETE',
  })

  invalidatesTags = (res: any, err: any, id: string) => [{ type: 'ProjectRole', id }] as const
}